import { random } from "nanoid";

const scale = {
    0: 156543.03392800014,
    1: 78271.5169538414,
    2: 39135.758476907,
    3: 19567.8792384535,
    4: 9783.9396192263,
    5: 4891.9698596130,
    6: 2445.98492988067,
    7: 1222.99245494033,
    8: 611.49622670269,
    9: 305.74811340384,
    10: 152.87405657042,
    11: 76.43702828521,
    12: 38.218514142606,
    13: 19.10925707131,
    14: 9.55462853565,
    15: 4.777314267829,
    16: 2.388657133915,
    17: 1.194328566957,
    18: 0.597164283478,
    19: 0.29858214164761665,
    20: 0.14929107082380833,
    21: 0.07464553541190416,
    22: 0.03732276770595208,
    23: 0.01866138385297604,
}

//0.14929107082380833 / 1.194328566957 = 100 / x
//1.194328566957 / 0.14929107082380833


const extractImageFromCanvas = (canvas, position, drawType) => {

    const imgWidth = position[2] - position[0];
    const imgHeight = position[3] - position[1];

    const newCanvas = document.createElement('canvas');
    newCanvas.width = imgWidth;
    newCanvas.height = imgHeight;
    const newCtx = newCanvas.getContext('2d');

     // Create circular clipping region
     if(drawType === 'Circle') {
        newCtx.beginPath();
        newCtx.arc(imgWidth/2, imgWidth/2, imgWidth/2, 0, 2 * Math.PI * 2);
        newCtx.clip();
     }

    newCtx.drawImage(canvas, position[0], position[1], imgWidth, imgHeight, 0, 0, imgWidth, imgHeight);


    // Manipulate canvas
    /*if(drawType === 'Circle') {
        
        let src = cv.imread(newCanvas);
        let tmp = new cv.Mat();
        let alpha = new cv.Mat();

        let rgbPlanes = new cv.MatVector();

        cv.cvtColor(src, tmp, cv.COLOR_RGBA2GRAY, 0);
        cv.threshold(tmp, alpha, 20, 255, cv.THRESH_BINARY);

        cv.split(alpha, rgbPlanes);

        for(let i = 0; i < rgbPlanes.get(0).rows; i++) {
            for(let j = 0; j < rgbPlanes.get(0).cols; j++) {
                let pixel = src.ucharPtr(i, j);
                pixel[3] = alpha.ucharPtr(i, j)[0] ? 255 : 0;
            }
        }

        //cv.merge(rgbPlanes.get(0), dst);
        
        cv.imshow(newCanvas, src);
        src.delete();
        tmp.delete();
        alpha.delete();
        rgbPlanes.delete();
        //return  dst.toDataURL('image/png');
    }*/

    const imageUrl = newCanvas.toDataURL('image/png');
    newCanvas.remove();

    return imageUrl;
}
const copyCanvas = (canvasSrc) => {

    const canvasDest = document.createElement('canvas');
    canvasDest.width = canvasSrc.width;
    canvasDest.height = canvasSrc.height;
    
    const newCtx = canvasDest.getContext('2d');
    newCtx.drawImage(canvasSrc, 0, 0);

    return canvasDest;
}
const createCanvasFromImage = (url, settings) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            const canvas = document.createElement('canvas'); // Destination
            const context = canvas.getContext('2d');

            //const randomRotation = Math.random() * 2 * Math.PI;
            const elementScale = (Math.random() * (settings.output.maxScale - settings.output.minScale) + settings.output.minScale) / 100;
            const randomRotation = (Math.random() * (settings.output.maxRotation - settings.output.minRotation) + settings.output.minRotation) * Math.PI/180;

            // const diagonal = Math.sqrt(newImageWidth * newImageWidth + newImageHeight * newImageHeight);
            const rotatedImageWidth = image.width * Math.abs(Math.cos(randomRotation)) + image.height * Math.abs(Math.sin(randomRotation));
            const rotatedImageHeight = image.height * Math.abs(Math.cos(randomRotation)) + image.width * Math.abs(Math.sin(randomRotation));
            

            const newImageWidth = Math.round(rotatedImageWidth) * elementScale; //* scale * 2;
            const newImageHeight = Math.round(rotatedImageHeight) * elementScale; // * scale * 2;

            if(newImageWidth <=10 || newImageHeight <= 10) reject('Image is too small');

            canvas.width = newImageWidth;
            canvas.height = newImageHeight;

            //context.save();
            //https://developer.mozilla.org/en-US/docs/Web/CSS/filter#blur()
            const filters = []

            // 0 - 360 ° default: 0
            const hueRotate = Math.round(Math.random() * (settings.output.hueRotateMax - settings.output.hueRotateMin) + settings.output.hueRotateMin);
            filters.push(`hue-rotate(${hueRotate}deg)`);

            // 10 - 190 % default: 100
            const brightness = Math.round(Math.random() * (settings.output.brightnessMax - settings.output.brightnessMin) + settings.output.brightnessMin);
            filters.push(`brightness(${brightness}%)`);
            
            // 10 - 190 % default: 100
            const contrast = Math.round(Math.random() * (settings.output.contrastMax - settings.output.contrastMin) + settings.output.contrastMin);
            filters.push(`contrast(${contrast}%)`);

            

            // 10 - 190 % default: 100
            const saturate = Math.round(Math.random() * (settings.output.saturationMax - settings.output.saturationMin) + settings.output.saturationMin);
            filters.push(`saturate(${saturate}%)`);

            // 0 - 10 px // default 0
            const blur = settings.output.blur;
            filters.push(`blur(${blur}px)`);
            

            context.filter = filters.join(' ');

            context.translate(newImageWidth/2, newImageHeight/2);
            context.rotate(randomRotation);
            
            context.drawImage(
                image,
                0,
                0,
                image.width,
                image.height,
                -image.width/2 * elementScale,
                -image.height/2 * elementScale,
                image.width * elementScale,
                image.height * elementScale,
            );
            
            context.rotate(-randomRotation);
            context.translate(-newImageWidth/2, -newImageHeight/2);
            //context.restore();

            


            resolve(canvas);
        };
        image.onerror = (err) => {
            reject(err);
        };
        image.src = url;
    });
}
const restrict = (value) =>{
    return Math.max(Math.min(value, 1), 0);
}
//canvas, mapExtent, settings.foreground.extents, settings
const addEntitiesToExtent = async (mapCanvas, background, imageList, settings) => {

    const baseCanvas = copyCanvas(mapCanvas);
    const baseContext = baseCanvas.getContext('2d');

    baseContext.save();
    const brightness = 5;
    baseContext.filter = `brightness(${brightness}%)`;
    baseContext.drawImage(mapCanvas, 0, 0);
    baseContext.restore();

    const imageIterations = 10 //Math.round(Math.random() * (count.to - count.from) + count.from);
    let annotation = [];

    for(let i = 0; i < imageIterations; i++) {
        try {
            
            const imageIndex = Math.round(Math.random() * (imageList.length - 1));
            const image = imageList[imageIndex];

            //const randomScale = scale[image.zoom] / scale[background.zoom] * Math.random() + 0.5; // TODO: make scale random
            //const randomRotation = Math.random() * 2 * Math.PI;

            const imageCanvas = await createCanvasFromImage(image.image, settings)

            
            const xPosition = Math.random()*(baseCanvas.width-imageCanvas.width); //*randomScale
            const yPosition = Math.random()*(baseCanvas.height-imageCanvas.height); //*randomScale
            

            baseContext.drawImage(
                imageCanvas,
                0,
                0,
                imageCanvas.width,
                imageCanvas.height,
                xPosition,
                yPosition,
                imageCanvas.width,
                imageCanvas.height,
            );


            //console.log(xPosition, imageCanvas.width, baseCanvas.width, restrict((xPosition+imageCanvas.width/2)/baseCanvas.width));
            annotation.push({
                label: image.label,
                left: restrict((xPosition+imageCanvas.width/2)/baseCanvas.width),
                top: restrict((yPosition+imageCanvas.height/2)/baseCanvas.height),
                width: restrict(imageCanvas.width/baseCanvas.width),
                height: restrict(imageCanvas.height/baseCanvas.height)
            });
        } catch(err) {
            console.log(err);
        }
    }

    return new Promise((resolve, reject) => {
        resolve({
            canvas: baseCanvas,
            annotation
        });

    });
}
const annotationFromExtent = (extent, foregroundExtents, ol, outputDimension) => {
    //1729854.6366317908, 6204299.927325541, 1729950.1829171472, 6204395.4736108985]
    //[minx, miny, maxx, maxy].
    const annotation = [];
    
    for(let i = 0; i < foregroundExtents.length; i++) {
        const element = foregroundExtents[i];

        const topLeft = ol.getPixelFromCoordinate([element.extent[0], element.extent[3]]);
        const bottomRight = ol.getPixelFromCoordinate([element.extent[2], element.extent[1]]);

        const width = (bottomRight[0] - topLeft[0]);
        const height = (bottomRight[1] - topLeft[1]);

        const center = [topLeft[0] + width/2, topLeft[1] + height/2];
        if(center[0] < 0 || center[0] > outputDimension[0] || center[1] < 0 || center[1] > outputDimension[1]) continue;

        annotation.push({
            label: element.label,
            left: center[0] / outputDimension[0],
            top: center[1] / outputDimension[1],
            width: width / outputDimension[0],
            height: height / outputDimension[1]
        });
    }

    return annotation;
}

export {extractImageFromCanvas, copyCanvas, addEntitiesToExtent, annotationFromExtent};